import { Image } from "db/definitions";
import { batchAddImages } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

async function batchCreateImages(images: Image[]): Promise<boolean> {
	if (images.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddImages,
				variables: { images: images as any[] },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
		}
		return false;
	}
	return true;
}

export default batchCreateImages;
